module.exports = __webpack_public_path__ + "static/media/hotel-large.023ab60d.webp";